export default "__VITE_ASSET__c5defb87__"